import React from "react";
import Section from "../components/shared/Section";
import Stat from "../components/shared/Stat";
import { highlights } from "../data/highlights";

export default function Highlights() {
  return (
    <Section id="highlights" className="bg-white/[0.03]">
      <h2 className="text-2xl sm:text-4xl font-semibold text-center">
        Excellence by{" "}
        <span className="text-yellow-700">the Numbers</span>
      </h2>

      <div className="lg:mt-12 mt-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {highlights.map((h, i) => {
          const Icon = h.icon;
          return (
            <div
              key={i}
              className="group flex flex-col items-center justify-center rounded-2xl border border-white/10 bg-gradient-to-br from-white/5 to-white/[0.02] p-8 text-center transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/10 hover:border-yellow-400/20 hover:bg-white/[0.06]"
            >
              {/* Icon */}
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-yellow-500/10 group-hover:bg-yellow-500/20 transition duration-300 mb-4">
                <Icon className="h-7 w-7 text-yellow-400 transition-transform duration-300 group-hover:scale-110" />
              </div>

              {/* Stat Value */}
              <p className="text-2xl sm:text-3xl font-bold text-yellow-300 tracking-tight">
                {h.value}
              </p>

              {/* Label */}
              <p className="mt-1 text-sm text-neutral-300">
                {h.label}
              </p>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
